import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
import { Link } from 'react-router';
import { setCookie } from '../../../../util/storage';

import eventsDoodle from '../../../../assets/images/doodles/events_doodle.png';
import './MultipleEventsModal.less';


class MultipleEventsModal extends Component {
  componentWillUnmount() {
    setCookie('hideMultipleEventsModal', true, 180);
  }

  render() {
    const { hideModalFn } = this.props;
    return (
      <div className="multiple-events-modal">
        <div className="header-img-container">
          <img className="header-img" src={eventsDoodle} alt="Welcome to multiple events" />
        </div>
        <div>
          <h5 className="super-header">We Heard You</h5>
          <h2 className="primary-header">Now Guests Can RSVP to Multiple Events</h2>
        </div>
        <div className="row sections">
          <div className="col-md-4">
            <h5 className="section-header">Create Events</h5>
            <p className="section-body">
              Rehearsal dinner? Morning-after brunch? Build guest lists for each.
            </p>
          </div>
          <div className="col-md-4">
            <h5 className="section-header">Edit Settings</h5>
            <p className="section-body">
              Customize event privacy and RSVP preferences.
            </p>
          </div>
          <div className="col-md-4">
            <h5 className="section-header">Track RSVPs</h5>
            <p className="section-body">
              Stay on top of guests&#39; responses for each event in our RSVP tracker.
            </p>
          </div>
        </div>
        <Link to="/wedding/manage/events" className="btn btn-primary btn-wide" onClick={hideModalFn}>
          Explore The New Events Page
        </Link>
      </div>
    );
  }
}

MultipleEventsModal.propTypes = {
  hideModalFn: PropTypes.func,
};

export default MultipleEventsModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/MultipleEventsModal/MultipleEventsModal.jsx